import firebase from "firebase/app";
import "firebase/auth";
import axios from "axios";

export const getFailedCashplusOperations = async (starDate, endDate) => {
  const token = await firebase.auth().currentUser.getIdToken();

  let url = `WafrConsole/GetFailedDepositOperations?startDate=${starDate}&endDate=${endDate}`;

  try {
    const response = await axios.get(url, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    if (response.status === 200 && response.data) {
      const data = response.data;
      console.log("data = ", data.data)
      return data.data;
    }
  } catch (e) {
    console.log("Error while getting Products");
    return null;
  }

  return [];
};

export const resendCashplusOperation = async (operationLogId) => {
  const token = await firebase.auth().currentUser.getIdToken();

  let url = `WafrConsole/ResendCashplusDeposit?operationLogId=${operationLogId}`;

  try {
    const response = await axios.post(url,{}, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    if (response.status === 200 && response.data) {
      const data = response.data;
      if (!data.success)
        alert(data.error)
      else
        alert("operation succeeded")
      return data.success;
    }
  } catch (e) {
    console.log("Error while getting Products");
    return null;
  }

  return [];
};


export const DownloadCashplusOperationsXlsx = async (starDate, endDate) => {
  const token = await firebase.auth().currentUser.getIdToken();

  let url = `WafrConsole/GenerateCashplusOperationsXlsx?startDate=${starDate}&endDate=${endDate}`;

  try {
    const response = await axios.get(url, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      responseType: "blob"
    });
    if (response.status === 200 && response.data) {
      let blobUrl = URL.createObjectURL(response.data);
      window.location.replace(blobUrl);  
    }
  } catch (e) {
    console.log(e,"Error while generating xlsx file");
    return null;
  }
};